module.exports = __webpack_public_path__ + "static/media/user.4616dd49.svg";